export const gdkRequestNoPartnerCenterAccountMessage =
  "You must be registered in Partner Center to access this page.";
export const gdkRequestUnauthorizedTitle = "Unauthorized";
export const gdkRequestUnauthorizedMessage = "None of your Publisher accounts are GDK-licensed.";
export const gdkRequestTitle = "Secure GDK Middleware Request";
export const gdkRequestNote =
  "The following third party engine, tools, and middleware providers are GDK-licensed and have opted into this automated validation system for GDK customer license requests. " +
  "By making your request via this system, your chosen third party technology provider(s) will know that you are a GDK-licensed developer, " +
  "so they will have no need to verify your license status with us. " +
  "You will remain responsible for any license fees associated with using their tools and technologies. " +
  "Please note that any personal information submitted to third party providers through this request system will be subject to the respective third party's privacy policies. " +
  "Some GDK-licensed engine, tools, and middleware partners have not opted into this request system and you should contact them directly with any licensing enquiries. " +
  "We are also in the process of signing up more providers of engines, tools, and middleware. " +
  "However, if you already are working with a provider that you require to create your GDK game title, " +
  "and if that provider is not GDK-licensed then please send mail to xbmw@microsoft.com. " +
  " We will do our best to work with all providers you specify in your request. A full list of our tools and middleware partners can be found in ";
export const gdkRequestNoteLink = "our documentation";
export const middlewarePartner = "Middleware partner";
export const gameDeveloperPublisher = "Game Developer/Publisher";
export const name = "Name";
export const emailLabel = "Email";
export const gdkRequestNoPreferredEmailFoundLabel = "No preferred email found";
export const gdkRequestNoPreferredEmailFoundMessage =
  "Not the right email? You can update your preferred email for communications in Partner Center. Please note that you may need to re-login for any updates to take effect.";
export const gdkRequestNoPreferredEmailFoundLink = "Go to Partner Center";
export const submitRequest = "Submit Request";
export const selectMiddlewareProvider = "Select middleware provider";
export const selectLabel = "Select";
export const goToPartnerCenter = "Go to Partner Center";
export const signUpToIdXbox = "Sign up to ID@Xbox";
export const unauthorizedSellersListPrefix =
  "These are the publishers you are part of that have no GDK-license: ";
export const confirmAccessRequest = "Confirm access request?";
export const thirdPartyPrivacyNotice =
  "Any personal information submitted to third parties through this request will be subject to their privacy policies";
export const cancel = "Cancel";
export const submitRequestButton = "Submit Request";
export const success = "Success";
export const successRequestMessage = "Request was sent successfully!";
export const onMicrosoftEmailsNotAllowed = "OnMicrosoft addresses are not allowed";
export const sendAnotherRequest = "Send another request";
